import type { ReactNode } from 'react'
import { useNls } from '../../../nls/nlsProvider'

export interface PulseSectionProps {
  done7d: number
  overdue: number
  openCount: number
  activeCount: number
  totalMembers: number
  budgetPercent?: number | null
  toolsNode?: ReactNode
}

export const PulseSection = ({
  done7d,
  overdue,
  openCount,
  activeCount,
  totalMembers,
  budgetPercent,
  toolsNode,
}: PulseSectionProps) => {
  const { t } = useNls()

  const activeDisplay = `${activeCount} / ${Math.max(1, totalMembers)}`

  return (
    <div style={{ position: 'relative', height: '100%' }}>
      {toolsNode}
      <div className="overviewKpis">
        <div className="overviewKpi">
          <div
            className="overviewKpi__icon"
            style={{ background: 'var(--success-soft)', color: 'var(--success)' }}
          >
            ✓
          </div>
          <div className="overviewKpi__val">{done7d}</div>
          <span className="overviewKpi__label">{t('NLSOverviewPulseDone7d')}</span>
        </div>

        <div className="overviewKpi">
          <div
            className="overviewKpi__icon"
            style={{ background: 'var(--danger-soft)', color: 'var(--danger)' }}
          >
            !
          </div>
          <div
            className="overviewKpi__val"
            style={{ color: overdue > 0 ? 'var(--danger)' : undefined }}
          >
            {overdue}
          </div>
          <span className="overviewKpi__label">{t('NLSOverviewPulseOverdue')}</span>
        </div>

        <div className="overviewKpi">
          <div
            className="overviewKpi__icon"
            style={{ background: 'var(--accent-soft)', color: 'var(--accent)' }}
          >
            ◎
          </div>
          <div className="overviewKpi__val">{activeDisplay}</div>
          <span className="overviewKpi__label">{t('NLSOverviewPulseActiveThisWeek')}</span>
        </div>

        <div className="overviewKpi">
          <div
            className="overviewKpi__icon"
            style={{ background: 'var(--info-soft)', color: 'var(--info)' }}
          >
            {budgetPercent != null ? '₹' : '☑'}
          </div>
          <div className="overviewKpi__val">
            {budgetPercent != null ? `${Math.round(budgetPercent)}%` : openCount}
          </div>
          <span className="overviewKpi__label">
            {budgetPercent != null
              ? t('NLSOverviewPulseBudgetUsed')
              : t('NLSOverviewPulseOpenItems')}
          </span>
        </div>
      </div>
    </div>
  )
}
